import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import QuoteWizardNavigation from './components/QuoteWizardNavigation';
import { II18nMessages } from '../../../../services/branding/models';
import { withRouter } from 'react-router';
import { flow, forEach } from 'lodash';
import { IHeaderActions } from './models';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as headerActions } from './reducer';
import { IChannel } from '../../../../data/api/models';
import { destroy } from 'redux-form';
import { IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { push } from 'react-router-redux';
import { IStore } from '../../../../redux/IStore';
import { IAuthState } from '../../../../services/auth/models';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

interface IHeaderProps {
  classes: any;
  isDrawerOpened: boolean;
  i18n: II18nMessages;
  auth: IAuthState;
  actions: {
    push: (route: string) => void;
    header: IHeaderActions;
    quote: IQuoteActions;
    destroy(formName: string);
  };
  steps: object;
  location: any;
  channel: IChannel;
  quote: IQuoteState;
}

class Header extends React.Component<IHeaderProps> {
  private renderAdditionalLogo = () => {
    const {channel} = this.props;

    if (!channel.additionalLogo) {
      return null;
    }

    return (
      <div className="additional-logo-container">
        <img src={channel.additionalLogo} alt={channel.key}/>
      </div>
    );
  }

  private renderLogo = () => {
    const {channel} = this.props;
    let logoSrc = null;
    let logoSmallSrc = null;
    let logoAlt = null;

    // TODO: Get the logos from the Theme
    if (channel.key === 'cpi-b2c') {
      logoSrc = require('./img/cpi-logo.jpg');
      logoSmallSrc = require('./img/cpi-mobile-logo.jpg');
      logoAlt = 'Staycationplan';
    }

    if (channel.key === 'tumc-b2c') {
      logoSrc = require('./img/tumc-logo.jpg');
      logoSmallSrc = require('./img/tumc-logo.jpg');
      logoAlt = 'Tumc';
    }

    if (channel.channelType === 'AGG') {
      return (
        <div>
          <div className="logo-agg-container">
            <img src={require('./img/free_spirit_agg_logo.png')} alt={'Free Spirit Medical'}/>
          </div>
          {this.renderAdditionalLogo()}
        </div>
      );
    }

    const getResizeClassName = (channelKey: string) => {
      switch (channelKey) {
        case 'tumc-b2c':
          return 'resize-tumc';
        case 'cpi-b2c':
          return 'resize-cpi';
        default:
          return '';
      }
    };

    const logoClass = [ 'logo-container', getResizeClassName(channel.key) ].join(' ');

    return (
      <div>
        <div className={logoClass}>
          <img src={logoSrc} alt={logoAlt} />
        </div>
        <div className={`logo-small ${channel.key === 'tam-b2c' || channel.key === 'tpl-b2c' && 'resize-tam'}`}>
          <img src={logoSmallSrc} alt={logoAlt} />
        </div>
      </div>
    );
  }

  private renderLinks = () => {
    const {channel, auth, location } = this.props;
    const isInAuthArea = location.pathname.match(/(auth)/);

    if (channel.channelType === 'AGG') {
      return null;
    }

    return (
      <div>
        <Navbar collapseOnSelect={true}>
          <Navbar.Header>
            <Navbar.Toggle/>
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight={true} className="links">
              {isInAuthArea && !auth.isAuthenticated ? (
                <LinkContainer to="/" exact={true}>
                  <NavItem eventKey={1}>
                    GET A QUOTE
                  </NavItem>
                </LinkContainer>
              ) : (
                <LinkContainer to={auth.isAuthenticated ? '/account/summary' : '/auth/login'} exact={true}>
                  <NavItem
                    eventKey={1}
                    href={auth.isAuthenticated ? '/account/summary' : '/auth/login'}
                  >
                    {auth.isAuthenticated ? 'MY ACCOUNT' : 'LOGIN'}
                  </NavItem>
                </LinkContainer>
              )}
              <NavItem
                eventKey={2}
                href={channel.urls.aboutUs}
                target="_blank"
                disabled={false}>
                ABOUT US
              </NavItem>
              <NavItem eventKey={3} href={channel.urls.contactUs} target="_blank" disabled={false}>
                CONTACT
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>);
  }

  private renderWizardNavigation = () => {
    const {steps, location, i18n, channel} = this.props;

    let currentStep = '';
    let isInQuoteProcess = false;

    forEach(steps, (step) => {
      if (step.route === location.pathname) {
        currentStep = step.key;
        isInQuoteProcess = true;
      }
    });

    if (isInQuoteProcess) {
      return (
        <QuoteWizardNavigation i18n={i18n} steps={steps} currentStep={currentStep} channel={channel} />
      );
    }
  }

  public render() {
    const { channel, quote } = this.props;
    const hasAggError = quote.aggError;

    let classes = '';

    if (channel.channelType === 'AGG') {
      classes += ' aggregator';
    }

    return (
      <header className={classes}>
        <div className="container">
          <div className="header-container">
            {this.renderLogo()}
            {!hasAggError && (
              <div className="more-info-container">
                {this.renderLinks()}
                <div className="phone">
                  {channel.phone}
                </div>
                <div className="opening-hours">
                  {channel.openingHours}
                </div>
              </div>
            )}
          </div>
        </div>
        {!hasAggError && (
          <div className="wizard-container">
            <div className="">
              {this.renderWizardNavigation()}
            </div>
          </div>
        )}
      </header>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      isDrawerOpened: state.header.isDrawerOpened,
      i18n: state.branding.i18n,
      channel: state.branding.channel,
      auth: state.auth,
      quote: state.quote,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        header: bindActionCreators({...headerActions}, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
  withRouter,
])(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Shell/scenes/Header/index.tsx